class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

    connectedCallback() {
    const defaultInput = this.querySelector('input:checked') || this.querySelector('input');

    if (defaultInput) {
      const simulatedEvent = { target: defaultInput };
			if(simulatedEvent) {
/*				this.change_custom_variant_image(simulatedEvent);*/
			}
    }

/*    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      const template = document.querySelector('body');

      const inputs_parent = target.closest('.product-form__input');
      const inputs = inputs_parent.querySelectorAll('input');

      inputs.forEach((input) => (input.checked = false));
      target.checked = true;

      const priceBox = target.closest('.variant_box');

      function getNum(string) {
        if(!string) return;

        return +string.match(/\d+(\.\d+)?/)[0];
      }

      let priceContent = null;
      let compareAtPrice = null;
      const currentVariantPrice = getNum(target.dataset.price) || null;
      const currentVariantComparePrice = getNum(target.dataset.compare) || null;

      if(!currentVariantComparePrice) {
        if(priceContent) {}
        priceContent = priceBox.querySelector('.product_price .price__regular .price-item');
        if(priceContent) {
          priceContent.textContent = target.dataset.price;
        }
      } else {
        priceContent = priceBox.querySelector('.product_price .price__sale .price-item.price-item--sale');
        compareAtPrice = priceBox.querySelector('.product_price .price__sale .price-item.price-item--regular');
        
        if(priceContent && compareAtPrice) {
          priceContent.textContent = target.dataset.price;
          compareAtPrice.textContent = target.dataset.compare;
        }
      }

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });

      this.updateSelectionMetadata(event);

      if (!template.dataset.template.includes('product')) {
        this.change_custom_variant_image(event);
        this.set_current_variant_id(event);
      }
    });*/
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
